import gql from 'graphql-tag';
import FieldsCredit from 'graphql/fields/FieldsCredit';
import FieldsTransaction from 'graphql/fields/FieldsTransaction';

export default gql(`
	query employee_transactions {
		employee_me {
			transactions {
				id
				${FieldsTransaction}

				credit_bundle {
					guid

					timeslot_kind {
						guid
					}
				}
			}
		}
	}
`);

